/**
 * Master switch for AdSense units. While AdSense is reviewing the domain
 * ("Low value content"), we render no <ins class="adsbygoogle"> tags at all
 * so the crawler doesn't see empty ad shells above the fold. The AdSense
 * <script> in loadAdSense.ts and the <meta name="google-adsense-account">
 * stay in place so the site tag remains verifiable.
 *
 * Flip via env: set VITE_ADSENSE_ENABLED=true in .env once AdSense approves,
 * or hard-code to true below.
 */
export const ADSENSE_ENABLED: boolean =
  (import.meta.env.VITE_ADSENSE_ENABLED ?? "false").toString().toLowerCase() === "true";
